var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Network Error")]),_c('p',[_vm._v("There was a network error. Please try again later.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }